module.exports = __webpack_public_path__ + "static/media/no_data.f2162c25.jpg";